import React from 'react';

import HeaderDark from '../../common/header/HeaderDark';
import FooterOne from '../../common/footer/FooterOne';

import pdt1 from '../../../src/app/assets/images/products/1.jpg'
import pdt2 from '../../../src/app/assets/images/products/2.jpg'
import pdt3 from '../../../src/app/assets/images/products/3.jpg'
import pdt4 from '../../../src/app/assets/images/products/4.jpg'
import pdt5 from '../../../src/app/assets/images/products/5.jpg'
import pdt6 from '../../../src/app/assets/images/products/6.jpg'
import pdt7 from '../../../src/app/assets/images/products/7.jpg'
import pdt8 from '../../../src/app/assets/images/products/8.jpg'
import pdt9 from '../../../src/app/assets/images/products/9.jpg'
import pdt10 from '../../../src/app/assets/images/products/10.jpg'

const products = () => {
return (
<div className="prod-page">
    <HeaderDark />
    <div className="pt-lg-5 prod-sec">
        <div class="container custom-cn-width">
            <div class="row g-5 justify-content-center text-center">
                <div class="col-lg-12 mb-4 mb-lg-5">
                    <h1 class="fw-light">Products that enlight your business development</h1>
                </div>
            </div>
            <div class="row g-xl-5 g-4">
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt1} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Medico-Risk Chart App</h5>
                            <p class="mt-2 font-size-17 text-dark">Validate Medical litigation risk factors using risk chart application</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt2} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Medico AI – Chrono Sort App</h5>
                            <p class="mt-2 font-size-17 text-dark">Automate and sort your medical records via Hybrid Intelligence</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt3} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Medico - View Desk</h5>
                            <p class="mt-2 font-size-17 text-dark">A digital viewpoint software for Medical reports</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt4} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark ">API CRM Suite</h5>
                            <p class="mt-2 font-size-17 text-dark">Synchronise Multi-Platform CRM via API</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt5} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Realtor Connect</h5>
                            <p class="mt-2 font-size-17 text-dark">Perfect platform for home buyers and sellers</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt6} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Joomla zone</h5>
                            <p class="mt-2 font-size-17 text-dark">Upgrade to the next gen mobile-ready and user-friendly CMS</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt7} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Legal-M App</h5>
                            <p class="mt-2 font-size-17 text-dark">Manage legal cases and its informational support</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt8} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">E-Sort Desk</h5>
                            <p class="mt-2 font-size-17 text-dark">Explore automated Sorting and categorising of documents on your demand</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt9} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Data Governance System</h5>
                            <p class="mt-2 font-size-17 text-dark">Manage and control data and its facts, all in one system</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="zoom transition h-100">
                        <div class="overflow-hidden">
                            <img src={pdt10} alt="product" class="img-fluid mb-1" />
                        </div>
                        <div class="prod-block transition p-4">
                            <h5 class="text-uppercase font-size-21 text-dark">Liti-code System</h5>
                            <p class="mt-2 font-size-17 text-dark">A complete framework system for litigation coding and encryption</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <FooterOne />
</div>
)
}

export default products;